'use strict';

angular.module('cgmemApp')
.factory('Notice', function ($rootScope, $http, $log) {

	var api = {};
	
	var notices = [];
	
	var getNotices = function() {
		$http.get('/api/notices')
		.then(function(d) {
			angular.copy(d.data, notices);
		}, function(err) {
			$rootScope.$emit('generalAlert',"Error retrieving notices");
		});
	}
	
	getNotices();
	
	api.get = function() {
		return notices;
	}

	api.upsertNotice = function(n) {
		$http.post('/api/notices', n)
		.then(function() {
		})
		.catch(function(err) {
			$rootScope.$emit('generalAlert',"Error updating Notices");
			$log.error("Error saving notice",err);
		});
	}
	
	$rootScope.$on('socket:notice', function(ev) {
		getNotices();
	});	
	
	return api;;
});
		